module.exports = __webpack_public_path__ + "img/SIDEBAR_dok.fdeb6853.svg";